import Model from "./Model";

export default class ProfissionalDeApoio extends Model {
  constructor(profissionalDeApoio) {
    super();
    Object.assign(this, profissionalDeApoio);
  }
}
